import { 
  appendText,
  getText
} from '../../../assets/js/text-renderer';

import './features-collector.scss';
import '../../shared/dynamic-tabs/dynamic-tabs.js';

export const loadText = async (mainFeaturesEl, ctaButtons) => {
  const data = await getText('platform/intelek-collector/intelek-collector-features')
  const content = data.stories[0].content;

  setHeroContent(content, ctaButtons, mainFeaturesEl);
  setFeaturedContent(content, mainFeaturesEl);
  setDataSourceContent(content, mainFeaturesEl);
  setFeaturesContent(content, mainFeaturesEl);
  setMonitoringContent(content, mainFeaturesEl);
}

function setHeroContent(content, ctaButtons, mainFeaturesEl) {
  appendText(content.hero_title, 'hero-title', mainFeaturesEl);
  appendText(ctaButtons.start_trial_btn, 'hero-cta-trial-button', mainFeaturesEl);
  appendText(ctaButtons.book_demo_btn, 'hero-cta-demo-button', mainFeaturesEl);
  appendText(content.summary, 'summary', mainFeaturesEl);
}

function setFeaturedContent(content, mainFeaturesEl) {
  appendText(content.featured[0].text, 'featured-option-0', mainFeaturesEl);
  appendText(content.featured[1].text, 'featured-option-1', mainFeaturesEl);
  appendText(content.featured[2].text, 'featured-option-2', mainFeaturesEl);
  appendText(content.featured[3].text, 'featured-option-3', mainFeaturesEl);
}

function setDataSourceContent(content, mainFeaturesEl) {
  appendText(content.sourcesTitle, 'sources-title', mainFeaturesEl);

  appendText(content.sourcesOptions[0].title, 'software-tab', mainFeaturesEl);
  appendText(content.sourcesOptions[0].description, 'software-text', mainFeaturesEl);
  appendText(content.sourcesOptions[1].title, 'db-tab', mainFeaturesEl);
  appendText(content.sourcesOptions[1].description, 'db-text', mainFeaturesEl);
  appendText(content.sourcesOptions[2].title, 'documents-tab', mainFeaturesEl);
  appendText(content.sourcesOptions[2].description, 'documents-text', mainFeaturesEl);
  appendText(content.sourcesOptions[3].title, 'scrapping-tab', mainFeaturesEl);
  appendText(content.sourcesOptions[3].description, 'scrapping-text', mainFeaturesEl);
  appendText(content.sourcesOptions[4].title, 'providers-tab', mainFeaturesEl);
  appendText(content.sourcesOptions[4].description, 'providers-text', mainFeaturesEl);
  appendText(content.sourcesOptions[5].title, 'fuentes-tab-6', mainFeaturesEl);
  appendText(content.sourcesOptions[5].description, 'fuentes-6-text', mainFeaturesEl);
}

function setFeaturesContent(content, mainFeaturesEl) {
  appendText(content.features_periodic_tasks, 'periodic-tasks', mainFeaturesEl);
  appendText(content.features_monitoring, 'monitoring', mainFeaturesEl);
}

function setMonitoringContent(content, mainFeaturesEl) {
  appendText(content.monitoringFeaturedTitle, 'monitoring-featured-title', mainFeaturesEl);
  appendText(content.monitoringFeaturedOptions[0].text, 'monitoring-feat-option-0', mainFeaturesEl);
  appendText(content.monitoringFeaturedOptions[1].text, 'monitoring-feat-option-1', mainFeaturesEl);
  appendText(content.monitoringFeaturedOptions[2].text, 'monitoring-feat-option-2', mainFeaturesEl);
}